import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.529 17.556c2.11 0 4.038-.308 5.45-.817.705-.254 1.302-.566 1.73-.93.426-.363.724-.815.724-1.342 0-.575-.354-1.06-.848-1.442-.498-.385-1.192-.71-2.01-.966-1.365-.427-3.13-.68-5.046-.68-1.74 0-3.354.209-4.656.566-.927.254-1.715.589-2.282.992-.558.397-.966.911-.966 1.53 0 .527.297.979.723 1.342.428.364 1.025.676 1.73.93 1.413.509 3.34.817 5.45.817Z",
  fill: "#525052",
  "fill-opacity": ".45",
  stroke: "#D5D4D6",
  "stroke-width": ".75",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "7.972",
  y: "5.19",
  width: "2.19",
  height: "9.49",
  rx: ".5",
  fill: "#434143",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "11.622",
  y: "3",
  width: "2.19",
  height: "11.68",
  rx: ".5",
  fill: "#434143",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "15.272",
  y: "5.19",
  width: "2.19",
  height: "9.49",
  rx: ".5",
  fill: "#434143",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }